
export enum LayoutVariant {
    DEFAULT = "DEFAULT",
    LOGIN = "LOGIN"
}
